"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("react-bootstrap/Card"));
var classMap_1 = __importDefault(require("../../../shared/utilities/classMap"));
function Standard(props) {
    var icon = props.icon, background = props.background, avatar = props.avatar, title = props.title, titleHTMLTag = props.titleHTMLTag, titleClassName = props.titleClassName, slogan = props.slogan, progress = props.progress, action = props.action, image = props.image, meta = props.meta;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        avatar,
        (icon || background || image) && (react_1.default.createElement("div", { className: "visual-action-image" },
            background,
            icon,
            image)),
        title && (react_1.default.createElement("div", null,
            react_1.default.createElement(Card_1.default.Title, { as: titleHTMLTag || "h2", className: (0, classMap_1.default)("card-title visual-action-title m-0 truncate-lines", titleClassName), title: title }, title),
            meta && react_1.default.createElement("div", { className: "visual-meta" }, meta))),
        slogan,
        progress && react_1.default.createElement("div", { className: "mb-3 w-100" }, progress),
        action));
}
exports.default = Standard;
